export const DEFAULT_NODE_JOB_CONFIG = { nodeConfig: { instanceType: '' } };

export const editHibernationScheduleQueryKey =
  'open-hibernation-schedule-for-edit';

export const createHibernationScheduleQueryKey = 'create-hibernation-schedule';
